<ng-container [formGroup]="formGroup">
  <nz-table
    #selectedRowsTable
    [nzData]="selectedRecordsArray"
    [nzFrontPagination]="false"
  >
    <thead>
      <tr>
        <th style="background-color: transparent">{{'Id' | translate}}</th>
        <th style="background-color: transparent">{{'Name' | translate}}</th>
        <th style="background-color: transparent"></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let data of selectedRowsTable.data">
        <tr *ngIf="data != null">
          <td>{{ data.Id ?? data.id }}</td>
          <td *ngIf="objectType !== 12">{{ data.Name ?? data.name }}</td>
          <td *ngIf="objectType === 12">{{ data.sku }} / {{ data.name }}</td>
          <td>
            <button
              nz-button
              nzType="default"
              nzDanger
              (click)="deleteRow(data)"
            >
              delete
            </button>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </nz-table>
  <!-- <app-products-table
    *ngIf="field.Object === 12"
    [products]="selectedRecordsArray"
    [isLoading]="isLoading"
    [listColumns]="listColumns"
    [selectable]="false"
    [withActions]="false"
  >
  </app-products-table> -->
  <button nz-button nzType="default" (click)="showRecordsModal()">
    <span nz-icon nzType="plus-circle" nzTheme="outline"></span>
    {{'Add Row' | translate}}
  </button>
</ng-container>

<ng-template #productsDrawerTemplate let-drawerRef="drawerRef">
  <div>
    <ng-container *ngIf="field.Object !== 12">
      <div style="width: 100%">
        <input
          style="width: 100%"
          nz-input
          [(ngModel)]="filterStatement"
          (blur)="getObjectRows(objectType, false)"
        />
      </div>
      <nz-table #rowSelectionTable [nzData]="records">
        <thead>
          <tr>
            <th></th>
            <th>{{'Id' | translate}}</th>
            <th>{{'Name' | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of rowSelectionTable.data">
            <td
              [nzChecked]="selectedRecords.has(data)"
              (nzCheckedChange)="onItemChecked(data, $event)"
            ></td>
            <td>{{ data.Id }}</td>
            <td>{{ data.Name }}</td>
          </tr>
        </tbody>
      </nz-table>
    </ng-container>
    <app-products-table
      *ngIf="field.Object === 12"
      [products]="records"
      [payload]="productsPayload"
      [isLoading]="isLoading"
      [totalCount]="totalProducts"
      [selectable]="true"
      [listColumns]="listColumns"
      [withActions]="false"
      [setOfSelectedProducts]="selectedRecords"
      (getProducts)="productsPayload = $event; getObjectRows(12, false)"
      (selectionChange)="onProductSelectionChange($event)"
      (headerFiltersChanged)="handleFiltersChanges($event)"
    >
    </app-products-table>
  </div>
</ng-template>
<ng-template #recordsDrawerFooter>
  <nz-space>
    <button nz-button nzType="primary" (click)="selectRows()" *nzSpaceItem>
      <span nz-icon nzType="plus-circle" nzTheme="outline"></span>
      {{'Submit' | translate}}
    </button>
    <button nz-button *nzSpaceItem (click)="cancelSelection()">{{'Cancel' | translate}}</button>
  </nz-space>
</ng-template>
